var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "help_svg__path-1",
    d: "M11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11m0-.88c5.59 0 10.12-4.53 10.12-10.12S16.59.88 11 .88.88 5.41.88 11 5.41 21.12 11 21.12m-1.046-6.674a.4.4 0 0 1-.1-.285v-.73q.033-.942.459-1.637.426-.693 1.211-1.548.602-.658.894-1.085.293-.428.343-.926.015-.07.016-.231 0-.82-.651-1.3-.653-.48-1.52-.48-.936 0-1.563.525t-.81 1.646q-.068.392-.435.392h-.735a.36.36 0 0 1-.259-.107.38.38 0 0 1-.108-.285 3.7 3.7 0 0 1 .526-1.806q.492-.827 1.387-1.317.894-.49 2.046-.49 1.221 0 2.055.446.836.445 1.237 1.165.4.72.4 1.522 0 .907-.383 1.566-.385.659-1.153 1.53-.636.73-.953 1.237a2.5 2.5 0 0 0-.367 1.13q-.033.499-.034.748-.083.427-.417.427h-.819a.35.35 0 0 1-.267-.107m.244 2.661a.4.4 0 0 1-.101-.279v-.981q0-.17.101-.288a.32.32 0 0 1 .257-.118h.968q.156 0 .265.118.11.12.11.288v.981a.38.38 0 0 1-.11.28.36.36 0 0 1-.265.11h-.968a.34.34 0 0 1-.257-.11"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help_svg__icons/help",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "help_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#help_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#help_svg__path-1",
    id: "help_svg__Combined-Shape",
    fill: "#386DB0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "help_svg__color/black-tint/0-000000",
    fill: "#D8D8D8",
    mask: "url(#help_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "help_svg__gray-70-4A4A4A",
    fill: "#000",
    d: "M0 0h22v22H0z"
  }))))));
};
export default SvgHelp;